module.exports = __webpack_public_path__ + "static/img/img2.2745920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/img2.png
// module id = kcDJ
// module chunks = 0